import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { default as SubscriptionsSectionContainer } from './SubscriptionsSection.container';
import { default as SubscriptionsSection } from './SubscriptionsSection';
import { default as SubscriptionsSectionBranched } from './SubscriptionsSection.deviation_gruser';

export default withFeatureBranch({
  gruser_subscriptions: SubscriptionsSectionBranched,
})(SubscriptionsSectionContainer(SubscriptionsSection));
